import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, role = "customer" }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="route-loading">Checking your account…</div>;
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : "/account"} state={{ from: location }} replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/account"} replace />;
  return children;
}
